import { render, staticRenderFns } from "./customer_tag_user.vue?vue&type=template&id=645dc2d6&scoped=true"
import script from "./customer_tag_user.vue?vue&type=script&lang=ts"
export * from "./customer_tag_user.vue?vue&type=script&lang=ts"
import style0 from "./customer_tag_user.vue?vue&type=style&index=0&id=645dc2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645dc2d6",
  null
  
)

export default component.exports